// Password gate — the site's identity moment: wordmark over the warm background,
// one field, nothing else. No content or category names load before this passes.
import React, { useState } from 'react';
import { api } from '../api.js';
import { LOGIN } from '../text.js';
import { HeartIcon } from '../components/icons.jsx';

export default function Login({ onLogin }) {
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [busy, setBusy] = useState(false);

	const submit = async (e) => {
		e.preventDefault();
		if (!password || busy) return;
		setBusy(true);
		setError('');
		try {
			await api.login(password);
			onLogin();
		} catch (err) {
			setError(err.status === 429 ? LOGIN.rateLimited : LOGIN.error);
		} finally {
			setBusy(false);
		}
	};

	return (
		<div className='login'>
			<div className='login__card'>
				<span className='login__heart' aria-hidden='true'>
					<HeartIcon size={30} />
				</span>
				<h1 className='login__title'>Herzensmomente</h1>
				<div className='login__sub'>{LOGIN.sub}</div>
				<form className='login__form' onSubmit={submit}>
					<label className='visually-hidden' htmlFor='login-password'>
						{LOGIN.placeholder}
					</label>
					<input
						id='login-password'
						className='login__input'
						type='password'
						autoComplete='current-password'
						placeholder={LOGIN.placeholder}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						autoFocus
					/>
					<button type='submit' className='btn btn--primary login__submit' disabled={busy || !password}>
						{busy ? '…' : LOGIN.submit}
					</button>
				</form>
				{error && (
					<div className='login__error' role='alert'>
						{error}
					</div>
				)}
			</div>
		</div>
	);
}
